import module from 'guest/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('guest.balance', {
    url: '/balance?{moneda:[12]}',
    params: {moneda: {value: '1', squash: true}},
    reloadOnSarch: false,
    resolve: {
      idMoneda: ($stateParams) => $stateParams.moneda,
      monedas: ($catalogos) => $catalogos.get('monedas'),
      balance: (auth, GuestBalance, idProyecto, idColaborador) => GuestBalance.get(idProyecto, idColaborador)
        .then((response) => response.data),
    },
    data: {title: 'guest.balance.title'},
    template: '<guest-balance id-moneda="idMoneda" balance="balance" monedas="monedas"></guest-balance>',
    controller: ($scope, idMoneda, balance, monedas) => {
      $scope.idMoneda = idMoneda
      $scope.balance = balance
      $scope.monedas = monedas
    },
  })
})



// WEBPACK FOOTER //
// ./src/guest/routes/guest/balance.js